enum CustomerGender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export default CustomerGender;
